import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import './Avatar.scss';
export const Avatar = ({ type, children }) => {
    return (_jsx("span", { className: classNames({
            'sg-avatar': true,
            'sg-avatar-dark': type === 'dark',
            'sg-avatar-light': type === 'light',
        }), children: children }));
};
//# sourceMappingURL=Avatar.js.map